/**
 * @file ProductTemplateBar.tsx
 * @description Полоса над канвой шаблона страницы товара (phase19.16 Р2а;
 * uiux-design-r2a §3, §6, §7): «Шаблон страницы товара — применяется к N
 * товарам» (N — товары, видимые на сайте; подсказка в `title`) и «Товар
 * для примера ▾». Товаров на сайте нет — честный текст: на канве образец.
 */

import { useBuilder } from "../builder-context";
import { SampleProductPicker } from "./SampleProductPicker";
import { pluralRu } from "../../../lib/plural";

export function ProductTemplateBar() {
  const b = useBuilder();
  const template = b.pages.template;
  if (!template) return null;
  const current = b.canvasTarget.product ?? template.sample;
  const n = template.appliesTo;
  return (
    // На телефоне — столбиком: текст строкой, выбор товара во всю ширину (иначе текст сжимается в колонку слов).
    <div className="flex shrink-0 flex-col gap-2 rounded-xl border-l-4 border-primary bg-primary/8 px-3 py-2 md:flex-row md:items-center md:gap-3">
      <p className="type-body min-w-0 text-on-surface md:flex-1" title="Все товары магазина, видимые на сайте">
        {n > 0
          ? `Шаблон страницы товара — применяется к ${n} ${pluralRu(n, ["товару", "товарам", "товарам"])}.`
          : "Чтобы увидеть шаблон, нужен хотя бы один товар на сайте. Пока показываем образец."}
      </p>
      {n > 0 ? <SampleProductPicker current={current} onPick={(product) => b.setCanvasTarget({ ...b.canvasTarget, product })} /> : null}
    </div>
  );
}
